import { render, staticRenderFns } from "./TournamentContact.vue?vue&type=template&id=909730bc"
import script from "./TournamentContact.vue?vue&type=script&lang=js"
export * from "./TournamentContact.vue?vue&type=script&lang=js"
import style0 from "./TournamentContact.vue?vue&type=style&index=0&id=909730bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports